/**
 * @generated SignedSource<<d1a7a342f6e692cefa33d4911349672f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreFlag = "Calendar" | "CustomerFeedback" | "EmployeeRole" | "GroupAccountsAndProfiles" | "MigratedTeamSchedule" | "OnbardedTeams" | "Product" | "ProductDateTracker" | "SignalWidget" | "TodoAsIssue" | "TodoNewTimlineAndComments" | "VersionSummer24";
export type UserLoggedInQuery$variables = Record<PropertyKey, never>;
export type UserLoggedInQuery$data = {
  readonly currentStore: {
    readonly flags: ReadonlyArray<StoreFlag>;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureFlag_store">;
  } | null;
  readonly home: {
    readonly __typename: "Organisation";
  } | {
    readonly __typename: "Store";
    readonly id: string;
    readonly timezone: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"UserLoggedInQuery_query">;
};
export type UserLoggedInQuery = {
  response: UserLoggedInQuery$data;
  variables: UserLoggedInQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flags",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserLoggedInQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserLoggedInQuery_query"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useHasFeatureFlag_store"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "home",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "Store",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Organisation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserLoggedInQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myRole",
            "storageKey": null
          },
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "home",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v0/*: any*/),
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "type": "Store",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "Organisation",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bdf1664b2871f90e77a50eb2d69e19b4",
    "id": null,
    "metadata": {},
    "name": "UserLoggedInQuery",
    "operationKind": "query",
    "text": "query UserLoggedInQuery {\n  ...UserLoggedInQuery_query\n  currentStore {\n    id\n    flags\n    ...useHasFeatureFlag_store\n  }\n  home {\n    __typename\n    ... on Store {\n      id\n      timezone\n      __typename\n    }\n    ... on Organisation {\n      __typename\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment UserLoggedInQuery_query on Query {\n  me {\n    id\n    flags\n  }\n  currentStore {\n    tier\n    name\n    myRole\n    id\n  }\n  home {\n    __typename\n    ... on Store {\n      id\n      name\n      timezone\n      __typename\n    }\n    ... on Organisation {\n      id\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useHasFeatureFlag_store on Store {\n  id\n  flags\n}\n"
  }
};
})();

(node as any).hash = "c762bbd68a661b0ce12be8d603e6c29d";

export default node;
